module.exports = __webpack_public_path__ + "static/img/pexels-photo-1315741.f46a49e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-photo-1315741.webp
// module id = DNax
// module chunks = 0